module.exports = __webpack_public_path__ + "img/c5.c418644f.jpg";